
<template>
  <section class="position-relative">
    <button @click="loginWithFacebook" class="btn">Login com Facebook</button>
    <!-- https://www.facebook.com/dialog/oauth?client_id=1252413999402529&display=page&extras={"setup":{"channel":"IG_API_ONBOARDING"}}&redirect_uri=https://afiliados.uol.com.br/app/story-insight&response_type=token&scope=instagram_basic,instagram_manage_insights,pages_manage_metadata,pages_read_engagement,pages_show_list,business_management -->

    <div v-if="getProfile" class="mb-4">
        <b-row class="content-settings mt-4">
          <b-col cols="12">
            <div class="d-flex align-items-center col">
              <div class="p2">
                <span class="notification-container-title">Perfil</span>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="content-settings mt-4">
          <b-col class="d-flex align-items-center topic-title">
            <div class="d-flex align-items-center col">
              <div class="p2">
                <span class="notification-container-title">ID</span>
              </div>
            </div>
          </b-col>
          <b-col class="d-flex align-items-center topic-title">
            <div class="d-flex align-items-center col">
              <div class="p2">
                <span class="notification-container-title">Username</span>
              </div>
            </div>
          </b-col>
          <b-col class="d-flex align-items-center topic-title">
            <div class="d-flex align-items-center col">
              <div class="p2">
                <span class="notification-container-title">Posts</span>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row
          class="pt-4 notifications"
          style="background-color:#fff"
        >
          <b-col cols="12" class="d-flex topic">
            <b-col class="d-flex align-items-center topic-title">
              <div class="p2">
                <span class="notification-container-type">
                  {{ getProfile && getProfile.id }}
                </span>
              </div>
            </b-col>
            <b-col class="d-flex align-items-center topic-title">
              <div class="p2">
                <span class="notification-container-type">
                  {{ getProfile && getProfile.username }}
                </span>
              </div>
            </b-col>
            <b-col class="d-flex align-items-center topic-title">
              <div class="p2">
                <span class="notification-container-type">
                  {{ getProfile && getProfile.media_count }}
                </span>
              </div>
            </b-col>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col cols="12" md="6">
          <div v-if="getPages.length" class="mt-4 mb-4">
              <b-row class="content-settings mt-4">
                <b-col cols="12">
                  <div class="d-flex align-items-center col">
                    <div class="p2">
                      <span class="notification-container-title">Páginas</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="content-settings mt-4">
                <b-col class="d-flex align-items-center topic-title">
                  <div class="d-flex align-items-center col">
                    <div class="p2">
                      <span class="notification-container-title">ID</span>
                    </div>
                  </div>
                </b-col>
                <b-col class="d-flex align-items-center topic-title">
                  <div class="d-flex align-items-center col">
                    <div class="p2">
                      <span class="notification-container-title">Nome</span>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row
                v-for="page in getPages"
                class="pt-4 notifications"
                style="background-color:#fff"
                :key="page.id"
              >
                <b-col cols="12" class="d-flex topic">
                  <b-col class="d-flex align-items-center topic-title">
                    <div class="p2">
                      <span class="notification-container-type">
                        {{ page.id }}
                      </span>
                    </div>
                  </b-col>
                  <b-col class="d-flex align-items-center topic-title">
                    <div class="p2">
                      <span class="notification-container-type">
                        {{ page.description }}
                      </span>
                    </div>
                  </b-col>
                </b-col>
              </b-row>
          </div>
        </b-col>

        <b-col cols="12" md="6">
          <div v-if="getMetadata" class="mt-4 mb-4">
            <b-row class="content-settings mt-4">
              <b-col cols="12">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Metadata</span>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row class="content-settings mt-4">
              <b-col class="d-flex align-items-center topic-title">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Descrição</span>
                  </div>
                </div>
              </b-col>
              <b-col class="d-flex align-items-center topic-title">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Valor</span>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row
              v-for="metadata in getMetadata"
              class="pt-4 notifications"
              style="background-color:#fff"
              :key="metadata.description"
            >
              <b-col cols="12" class="d-flex topic">
                <b-col class="d-flex align-items-center topic-title">
                  <div class="p2">
                    <span class="notification-container-type">
                      {{ metadata.description }}
                    </span>
                  </div>
                </b-col>
                <b-col class="d-flex align-items-center topic-title">
                  <div class="p2">
                    <span class="notification-container-type">
                      {{ metadata.value }}
                    </span>
                  </div>
                </b-col>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6">
          <div v-if="getPosts.length" class="mt-4 mb-4">
            <b-row class="content-settings mt-4">
              <b-col cols="12">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Postagens</span>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row class="content-settings mt-4">
              <b-col class="d-flex align-items-center topic-title">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">ID</span>
                  </div>
                </div>
              </b-col>
              <b-col class="d-flex align-items-center topic-title">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Descrição abreviada</span>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row
              v-for="post in getPosts"
              class="pt-4 notifications"
              style="background-color:#fff"
              :key="post.id"
            >
              <b-col cols="12" class="d-flex topic">
                <b-col class="d-flex align-items-center topic-title">
                  <div class="p2">
                    <span class="notification-container-type">
                      {{ post.id }}
                    </span>
                  </div>
                </b-col>
                <b-col class="d-flex align-items-center topic-title">
                  <div class="p2">
                    <span class="notification-container-type">
                      {{ post.caption }}
                    </span>
                  </div>
                </b-col>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col cols="12" md="6">
          <div class="mt-4 mb-4">
            <b-row class="content-settings mt-4">
              <b-col cols="12">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Métricas</span>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row class="content-settings mt-4">
              <b-col class="d-flex align-items-center topic-title">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Insight</span>
                  </div>
                </div>
              </b-col>
              <b-col class="d-flex align-items-center topic-title">
                <div class="d-flex align-items-center col">
                  <div class="p2">
                    <span class="notification-container-title">Total</span>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row
              class="pt-4 notifications"
              style="background-color:#fff"
            >
              <b-col cols="12" class="d-flex topic">
                <b-col class="d-flex align-items-center topic-title">
                  <div class="p2">
                    <span class="notification-container-type">
                       insight.description
                    </span>
                  </div>
                </b-col>
                <b-col class="d-flex align-items-center topic-title">
                  <div class="p2">
                    <span class="notification-container-type">
                       insight.value
                    </span>
                  </div>
                </b-col>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
  </section>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters } from 'vuex';

export default {
  name: 'StoryInsightsForm',
  data() {
    return {
    };
  },
  methods: {
    loginWithFacebook() {
      window.FB.login((response) => {
        if (response.authResponse) {
          this.accessToken = response.authResponse.accessToken;
          localStorage.setItem('accessToken', this.accessToken);
          this.result = 'Login bem-sucedido!';
          localStorage.setItem('result', JSON.stringify(this.result));
        }
      }, {
        scope: 'pages_show_list,pages_manage_metadata,pages_read_engagement,instagram_basic,instagram_manage_insights',
      });
    },
  },
  computed: {
    ...mapGetters(['instagramPages', 'instagramMetadata', 'instagramPosts', 'instagramProfile']),
    getPages() {
      return this.instagramPages;
    },
    getMetadata() {
      return this.instagramMetadata;
    },
    getPosts() {
      return this.instagramPosts;
    },
    getProfile() {
      return this.instagramProfile;
    },
    getInsights() {
      return undefined;
    },
  },
};
</script>

<style lang="scss">
.topic {
  background: #fff;
}

.page-title {
  color: #7a3805;
  font-size: 20px;
  font-weight: bold;
}
.notification-container-title {
  color: #7a3805;
  font-size: 18px;
  font-weight: bold;
}

.green {
  color: #57b965 !important;
}

.notification-container-type {
  color: #7a3805;
  font-size: 16px;
}

.notification-container-text {
  color: #515151;
  font-size: 16px;
  font-weight: lighter;
}

.control-text {
  color: #515151;
  font-size: 16px;
  font-weight: lighter;
}

.content-settings {
  background: #f6f6f6 0% 0% no-repeat padding-box;
  padding-top: 25px;
  padding-bottom: 25px;
}

.channel-configuration,
.channel-configuration-controls {
  background-color: #efefef;
}

.text-channel-selec {
  font-size: 14px;
  color: #565656;
}

.col-channel-selector-title {
  border-bottom: 2px solid #dedddb;
}

input[type="checkbox"]:checked {
  background-color: #e38931 !important;
  color: #fff;
}

.notification-container-type-payment {
  color: #57b965;
  font-size: 16px;
}

/* css to toggle button */
.btn-toggle-active {
  width: 34px;
  height: 14px;
  border-radius: 20px;
  background-color: #ecc2bc !important;
  position: relative;
  cursor: pointer;
}

.btn-toggle-active .status {
  width: 18px;
  height: 18px;
  background-color: #d06859 !important;
  border-radius: 100%;
  position: absolute;
  top: -2px;
  right: 0 !important;
}

.btn-toggle-deactive {
  width: 34px;
  height: 14px;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  background-color: #b8b8b8;
}

.btn-toggle-deactive .status {
  width: 18px;
  height: 18px;
  left: 0 !important;
  background-color: #818181;
  position: absolute;
  border-radius: 100%;
  top: -2px;
}

 @media screen and (max-width: $sm) {
    .topic-title{
      width: 100%;
    }
  }
</style>
